<template>
  <!-- 底部导航栏容器 -->
  <div class="custom-tabbar" :style="{ height: tabbarHeight + 'px', backgroundColor: bgColor }">
    <div 
      v-for="(item, index) in tabbarList" 
      :key="index"
      class="tabbar-item"
      :class="{ 'tabbar-item--active': activeIndex === index }"
      @click="handleItemClick(item, index)"
    >
      <!-- 图标区域 -->
      <div class="tabbar-icon">
        <!-- 自定义图标（优先使用slot） -->
        <slot 
          :name="`icon-${index}`" 
          :is-active="activeIndex === index"
        >
          <!-- 默认图标（支持iconfont或图片） -->
          <i 
            v-if="item.icon" 
            :class="['tabbar-icon__default', item.icon]"
            :style="{ color: activeIndex === index ? activeColor : inactiveColor }"
          ></i>
          <img 
            v-else-if="item.iconUrl" 
            :src="activeIndex === index ? (item.activeIconUrl || item.iconUrl) : item.iconUrl"
            alt="tab-icon"
            class="tabbar-icon__img"
          >
        </slot>
        
        <!-- 徽章提示 -->
        <span 
          v-if="item.badge !== undefined && item.badge > 0"
          class="tabbar-badge"
          :style="{ backgroundColor: badgeBgColor, color: badgeColor }"
        >
          {{ item.badge > 99 ? '99+' : item.badge }}
        </span>
      </div>
      
      <!-- 文字区域 -->
      <div 
        class="tabbar-text"
        :style="{ 
          color: activeIndex === index ? activeColor : inactiveColor,
          fontSize: textSize + 'px'
        }"
      >
        <slot :name="`text-${index}`">
          {{ item.text }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTabbar',
  props: {
    // 导航栏列表配置
    tabbarList: {
      type: Array,
      required: true,
      validator: (value) => {
        // 校验每个选项的必填字段
        return value.every(item => {
          return item.text !== undefined && (item.icon || item.iconUrl || item.slotName)
        })
      }
    },
    // 当前激活索引
    activeIndex: {
      type: Number,
      default: 0
    },
    // 激活状态颜色
    activeColor: {
      type: String,
      default: '#1989fa' // 默认vant风格蓝色
    },
    // 未激活状态颜色
    inactiveColor: {
      type: String,
      default: '#969799'
    },
    // 背景色
    bgColor: {
      type: String,
      default: '#ffffff'
    },
    // 导航栏高度（px）
    tabbarHeight: {
      type: Number,
      default: 50
    },
    // 文字大小（px）
    textSize: {
      type: Number,
      default: 11
    },
    // 徽章背景色
    badgeBgColor: {
      type: String,
      default: '#ff4d4f'
    },
    // 徽章文字颜色
    badgeColor: {
      type: String,
      default: '#ffffff'
    },
    // 是否启用路由模式（item需配置path）
    useRouter: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleItemClick(item, index) {
      // 路由模式：跳转路由
      if (this.useRouter && item.path) {
        this.$router.push(item.path)
      }
      // 非路由模式：触发回调事件
      this.$emit('tab-click', { item, index })
      // 触发更新激活状态事件（如果父组件需要手动控制）
      this.$emit('update:activeIndex', index)
    }
  }
}
</script>

<style scoped lang="scss">
.custom-tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
  z-index: 999;

  .tabbar-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 4px 0;
    box-sizing: border-box;

    // 激活状态缩放效果
    &--active {
      .tabbar-icon {
        transform: scale(1.1);
        transition: transform 0.2s ease;
      }
    }

    .tabbar-icon {
      position: relative;
      margin-bottom: 2px;

      .tabbar-icon__default {
        font-size: 22px;
      }

      .tabbar-icon__img {
        width: 22px;
        height: 22px;
        object-fit: contain;
      }

      .tabbar-badge {
        position: absolute;
        top: -4px;
        right: -8px;
        min-width: 16px;
        height: 16px;
        line-height: 16px;
        border-radius: 8px;
        font-size: 10px;
        text-align: center;
        padding: 0 3px;
      }
    }

    .tabbar-text {
      line-height: 1;
    }
  }
}

// 适配iPhone底部安全区
// @media (max-width: 375px) and (device-pixel-ratio: 3),
//        (max-width: 414px) and (device-pixel-ratio: 3),
//        (max-width: 390px) and (device-pixel-ratio: 3) {
//   .custom-tabbar {
//     padding-bottom: constant(safe-area-inset-bottom);
//     padding-bottom: env(safe-area-inset-bottom);
//     height: calc(#{$tabbarHeight}px + constant(safe-area-inset-bottom));
//     height: calc(#{$tabbarHeight}px + env(safe-area-inset-bottom));
//   }
// }
</style>